/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_UndoInputs */

const en_shortcut_undo = /** @type {(inputs: Shortcut_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo the last save of a grid`)
};

/**
* | output |
* | --- |
* | "Undo the last save of a grid" |
*
* @param {Shortcut_UndoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shortcut_undo = /** @type {((inputs?: Shortcut_UndoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_UndoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shortcut_undo(inputs)
});